export function operacaoRadPesquisaPreGaturaUnidataInRequest(params = {}) {
  return {
    type: '@operacaoradpesquisaprefaturaunidata/RADPESQUISAPREFATURAUNIDATA_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoRadPesquisaPreFaturaUnidata(fatu_codigo) {
  return {
    type: '@operacaoradpesquisaprefaturaunidata/FIND_RADPESQUISAPREFATURAUNIDATA',
    payload: { fatu_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoradpesquisaprefaturaunidata/FAILED_REQUEST',
  };
}

export function deleteOperacaoRadPesquisaPreFaturaUnidata(fatu_codigo, params) {
  return {
    type: '@operacaoradpesquisaprefaturaunidata/DELETE_RADPESQUISAPREFATURAUNIDATA',
    payload: { fatu_codigo, params },
  };
}

export function updateOperacaoRadPesquisaPreFaturaUnidata(operacaoradpesquisaprefaturaunidata, params) {
  return {
    type: '@operacaoradpesquisaprefaturaunidata/UPDATE_RADPESQUISAPREFATURAUNIDATA',
    payload: { operacaoradpesquisaprefaturaunidata, params },
  };
}

export function storeOperacaoRadPesquisaPreFaturaUnidata(operacaoradpesquisaprefaturaunidata, params) {
  return {
    type: '@operacaoradpesquisaprefaturaunidata/STORE_RADPESQUISAPREFATURAUNIDATA',
    payload: { operacaoradpesquisaprefaturaunidata, params },
  };
}

export function successInRequest(
  operacaoradpesquisaprefaturaunidata,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoradpesquisaprefaturaunidata/SUCCESS_IN_REQUEST',
    payload: { operacaoradpesquisaprefaturaunidata, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoradpesquisaprefaturaunidata) {
  return {
    type: '@operacaoradpesquisaprefaturaunidata/SUCCESS_REQUEST',
    payload: { operacaoradpesquisaprefaturaunidata },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoradpesquisaprefaturaunidata/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoradpesquisaprefaturaunidata/RECORD_FILTERING',
    payload: { params },
  };
}
